var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimeCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #acbf37;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.39,7.62h0C39.31,2.54,32.66,0,26,0S12.69,2.54,7.62,7.62h0c-10.15,10.15-10.15,26.62,0,36.77h0c5.08,5.08,11.73,7.62,18.39,7.62s13.31-2.54,18.39-7.62h0c10.15-10.15,10.15-26.62,0-36.77Zm-2.04,34.73c-4.37,4.37-10.17,6.77-16.34,6.77s-11.98-2.4-16.34-6.77c-4.37-4.37-6.77-10.17-6.77-16.34s2.4-11.98,6.77-16.34c4.37-4.37,10.17-6.77,16.34-6.77s11.98,2.4,16.34,6.77c4.37,4.37,6.77,10.17,6.77,16.34s-2.4,11.98-6.77,16.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.2,15.58c-.45-.45-1.18-.45-1.63,0l-17.57,17.57-7.56-7.56c-.45-.45-1.18-.45-1.63,0l-.41.41c-.45.45-.45,1.18,0,1.63l8.38,8.38.2.2.2.2c.45.45,1.18.45,1.63,0l18.79-18.79c.45-.45.45-1.18,0-1.63l-.41-.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimeCheck);
export default __webpack_public_path__ + "static/media/lime-check.846e6565a0601c2dbea03a684210831a.svg";
export { ForwardRef as ReactComponent };